import FollowersTable from './FollowersTable';

export default FollowersTable;
